import React, { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { Option, OptionsList, DangerOption } from './style'
import { Bot, Tag, SquarePen, Users, Share2, Archive, Trash2 } from 'lucide-react'
import axios from '../../../../config/axios'
import { usePipelineContext } from '../PipelineContext'

interface PropsType {
  onClose: () => void
  onConfigurePipeline: () => void
  onViewTags: () => void
  onViewAutomations: () => void
  pipelineId: number
  pipelineName: string
}

const PipelineOptionsDropdown: React.FC<PropsType> = ({ onClose, onConfigurePipeline, onViewTags, onViewAutomations, pipelineId, pipelineName }) => {
  const dropdownRef = useRef<HTMLUListElement | null>(null)
  const navigate = useNavigate()
  const { showArchived, setShowArchived } = usePipelineContext()

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        onClose()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [onClose])

  const handleArchived = () => {
    setShowArchived(!showArchived)
    onClose()
  }

  const handleDelete = async () => {
    const confirmed = window.confirm(`Deseja excluir o funil "${pipelineName}"?`)
    if (!confirmed) return
    try {
      await axios.delete(`${process.env.REACT_APP_GATEWAY_BASE_URL}/pipelines/pipeline/${pipelineId}`)
      onClose()
      navigate('/panel')
    } catch (error) {
      console.error('Erro ao excluir funil:', error)
    }
  }

  const handleAccess = () => {
    alert('Funcionalidade de acessos em desenvolvimento')
    onClose()
  }

  const handleIntegrations = () => {
    alert('Funcionalidade de integrações em desenvolvimento')
    onClose()
  }

  return (
    <OptionsList ref={dropdownRef}>
      <Option onClick={() => {
        onViewAutomations()
        onClose()
      }}>
        <Bot size={18} /> Automação
      </Option>
      <Option onClick={() => {
        onViewTags()
        onClose()
      }}>
        <Tag size={18} /> Tags
      </Option>
      <Option onClick={() => {
        onConfigurePipeline()
        onClose()
      }}>
        <SquarePen size={18} /> Editar
      </Option>
      <Option onClick={handleAccess}>
        <Users size={18} /> Acessos
      </Option>
      <Option onClick={handleIntegrations}>
        <Share2 size={18} /> Integrações
      </Option>
      <Option onClick={handleArchived}>
        <Archive size={18} /> {showArchived ? 'Voltar aos cards' : 'Arquivados'}
      </Option>
      <DangerOption onClick={handleDelete}>
        <Trash2 size={18} /> Excluir
      </DangerOption>
    </OptionsList>
  )
}

export default PipelineOptionsDropdown

